import { useEffect, useState } from 'react';
import { IconWrapper } from '@flexo/general';
import { FooterProps } from '@flexo/organisms';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import styles from './footer.module.scss';
import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch } from 'react-redux';
import { navigateToMember, navigateToSite, navigateToCommunity } from '@flexo/resolvers';
import { Keyboard } from '@capacitor/keyboard';
import { METADATA } from '@flexo/reducers';
const ENV = (import.meta as any).env;

export function Footer({
  sections,
  shadow,
  roundCorners,
}: FooterProps) {
  const { Footer__Label, Footer__Label__Active } = styles;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];
  const dispatch = useDispatch();

  const metadata = useSelector((state: any) => state.metadata);

  const activeModule = pathSegment || 'household';

  let isActiveSection = activeModule ? activeModule : null;

  function getCommunitySite() {

    if (metadata?.prevSelectedEntityId) {
      return metadata?.prevSelectedEntityId;
    }

    let communitySite =
      (metadata?.entities as any)?.site?.find(
        (site: any) => site.communityId === params.id
      )?.siteId || null;

    if (!communitySite) {
      communitySite = (metadata?.entities as any)?.site?.[0]?.siteId || null;
    }

    return communitySite;
  }

  // Handle section change
  const handleSectionChange = (section: string) => {
    if (section === 'community') {

      dispatch(METADATA.SetPrevSelectedEntityId((params?.id || null) as any));

      navigateToCommunity(
        'community',
        pathSegment === 'community'
          ? params.id
          : metadata?.selectedEntity?.communityId ||
              metadata?.entities?.community?.[0]?.communityId
      );
    } else {
      navigateToSite('household', getCommunitySite());
      isActiveSection = section;
    }
  };
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    Keyboard.addListener('keyboardWillShow', () => setIsKeyboardOpen(true));
    Keyboard.addListener('keyboardWillHide', () => setIsKeyboardOpen(false));

    return () => {
      try {
        Keyboard.removeAllListeners();
      } catch (error) {
        console.log(error);
      }
    };
  }, []);

  return (
    <div
      className={`${styles.Footer} sfPro ${shadow ? styles.shadow : ''} 
      ${roundCorners ? styles.roundCorners : ''}`}
      style={isKeyboardOpen ? { display: 'none' } : ENV?.VITE_APP_NAME !== 'plenitude' ? { alignItems: 'center' } : {}}
    >
      

      {/* Map through sections and display icons */}
      {sections?.map((section) => (
        <div
          key={section}
          className={`${Footer__Label} ${
            isActiveSection === section ? Footer__Label__Active : ''
          }`}
          onClick={() => handleSectionChange(section)}

        >
          <IconWrapper
            iconName={`${section}${
              isActiveSection === section ? '_active' : ''
            }`}
          />
          <div
            className={isActiveSection === section ? 'color-primary-500' : ''}
            style={{ marginTop: '-8px', textTransform: 'uppercase' }}
          >
            {t(`widgets.footer.sections.${section}`)}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Footer;
